module.exports = {
          srcSet: __webpack_public_path__ + "f0cd3dbd.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "f0cd3dbd.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "f0cd3dbd.jpg",
          toString:function(){return __webpack_public_path__ + "f0cd3dbd.jpg"},
          
          width: 330,
          height: 200
        }